import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DadosIniciais from './dadosIniciais';
import { configuracaoDdi } from '../../../../store/ddi/actions';

const mapStateToProps = (state) => ({
  ddiReducer: state.ddiReducer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    configuracaoDdi
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DadosIniciais);
